import React from "react";
import { Pagination, Button } from "zina-dogi-react";
import { Link } from "react-router-dom";
import { service as costpackageService } from "../redux";
import swal from "sweetalert";

const titles = ["Cost Package Code", "Cost Package Description", "Cost Package Status"];

const CostPackageTable = ({ list, pagination, ...props }) => {
    const { className } = props;
    const costpackageTable_op = {
        className: ["costpackage_table", className].join(" ")
    };

    return (
        <div {...costpackageTable_op}>
            <nav className="navbar">
                <span className="navbar-brand h4" />
                <div>
                    <Button
                        color="primary"
                        className="ml-1 mr-1"
                        onClick={() => {
                            costpackageService.requestReport().then(data => {
                                if (data && data.detail) {
                                    swal({
                                        title: "Successfully!",
                                        text: data.detail,
                                        icon: "success",
                                        timer: 3000,
                                        button: true
                                    });
                                }
                            });
                        }}
                    >
                        Cost Package Report
                    </Button>
                    <Link to="/costpackage/importer" className="btn-success btn zina-btn ml-1 mr-1">
                        Add or Edit Cost Package
                    </Link>
                </div>
            </nav>
            <br />
            <div className="content">
                <table className="table table-bordered table-striped">
                    <thead className="thead-dark">
                        <tr>
                            {titles &&
                                titles.map((title, index) => (
                                    <th key={`cpo_title_${index}`} scope="col">
                                        {title}
                                    </th>
                                ))}
                        </tr>
                    </thead>
                    <tbody>{computeRows(list)}</tbody>
                </table>
            </div>
            <Pagination {...pagination} />
        </div>
    );
};

const computeRows = list => {
    const values = Object.values(list);
    if (values.length > 0) {
        return values.map((costpackage, i) => {
            return (
                <tr key={`costpackage_${i}`} style={{ textAlign: "center" }}>
                    <td>
                        <Link to={`/costpackage/detail/${costpackage.id}`}>{costpackage.code}</Link>
                    </td>
                    <td>{costpackage.name}</td>
                    <td>{costpackage.cancelled ? "Cancelled" : "Active"}</td>
                </tr>
            );
        });
    } else {
        return (
            <tr>
                <td colSpan={titles.length}>No data found</td>
            </tr>
        );
    }
};

export default CostPackageTable;
